import { createSlice } from "@reduxjs/toolkit";
import { LedgerEntrySummaryDto } from "../../shared/dtos/ledgerEntry/LedgerEntrySummaryDto";
import {
  getInitialListState,
  generateListReducers,
} from "../utils/listFactory";

export const ledgerEntrySlice = createSlice({
  name: "ledgerEntry",
  initialState: getInitialListState<LedgerEntrySummaryDto>(),
  reducers: {
    ...generateListReducers<LedgerEntrySummaryDto>(),
  },
});

export const ledgerEntryActions = ledgerEntrySlice.actions;
export default ledgerEntrySlice.reducer;
